import React from 'react';
import {isEmpty} from 'lodash';
import {Table, Input, Button, Select} from 'semantic-ui-react';

const FormSubContract = (props) => {
  const {
    id,
    numInvoice,
    observation,
    total,
    handleChange,
    handleAddItem,
    subcontractOptions,
    subcontractObject,
    totalTde,
    totalProvider,
    totalDealer,
  } = props;
  const validateBtn = numInvoice === '' || total <= 0;

  return (
    <Table.Row>
      <Table.Cell>
        <Select
          options={subcontractOptions}
          className='twc-subcontract-input code-input'
          placeholder='No.Operación'
          value={id}
          onChange={(e, {value}) => handleChange('id', value)}
        />
      </Table.Cell>
      <Table.Cell>
        <Input
          className='twc-subcontract-input description-input'
          placeholder='Descripción código'
          value={
            isEmpty(subcontractObject) ? '' : subcontractObject[id].description
          }
        />
      </Table.Cell>
      <Table.Cell>
        <Input
          className='twc-subcontract-input'
          placeholder='No. de factura'
          value={numInvoice}
          onChange={(e, {value}) => handleChange('numInvoice', value)}
        />
      </Table.Cell>
      <Table.Cell>
        <Input
          className='twc-subcontract-input'
          placeholder='Observación'
          value={observation || ''}
          onChange={(e, {value}) => handleChange('observation', value)}
        />
      </Table.Cell>
      <Table.Cell>
        <Input
          className='twc-subcontract-input'
          placeholder='Total dealer'
          value={totalDealer || total}
          type='number'
          min='0'
          step='0.1'
          pattern='^\d+(?:\.\d{1,2})?$'
          onChange={(e, {value}) => handleChange('totalDealer', value)}
        />
      </Table.Cell>
      <Table.Cell>
        <Input
          className='twc-subcontract-input'
          placeholder='Total TDE'
          value={totalTde || total}
          type='number'
          min='0'
          step='0.1'
          pattern='^\d+(?:\.\d{1,2})?$'
          onChange={(e, {value}) => handleChange('totalTde', value)}
        />
      </Table.Cell>
      <Table.Cell>
        <Input
          className='twc-subcontract-input'
          placeholder='Total Fabricante'
          value={totalProvider || 0}
          type='number'
          min='0'
          step='0.1'
          pattern='^\d+(?:\.\d{1,2})?$'
          onChange={(e, {value}) => handleChange('totalProvider', value)}
        />
      </Table.Cell>
      <Table.Cell>
        <Input
          className='twc-subcontract-input value-input'
          placeholder='Total'
          value={total}
          type='number'
          min='0'
          onChange={(e, {value}) => handleChange('total', value)}
        />
      </Table.Cell>
      <Table.Cell>
        <Button
          disabled={validateBtn}
          onClick={() => handleAddItem()}
          size='mini'
          color='green'
        >
          Agregar
        </Button>
      </Table.Cell>
    </Table.Row>
  );
};

export default FormSubContract;
